'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'gamepad-modern';
var width = 576;
var height = 512;
var aliases = [127918,63676,"gamepad-alt"];
var unicode = 'e5a2';
var svgPathData = 'M376 32c110.5 0 200 89.5 200 200l0 151.7c0 53.2-43.1 96.3-96.3 96.3-41.5 0-78.3-26.5-91.4-65.9l-10.1-30.1-180.4 0-10.1 30.1C174.6 453.5 137.8 480 96.3 480 43.1 480 0 436.9 0 383.7L0 232C0 121.5 89.5 32 200 32l176 0zM200 48C98.4 48 16 130.4 16 232l0 151.7c0 44.4 36 80.3 80.3 80.3 34.6 0 65.3-22.1 76.2-54.9l11.9-35.6 1.2-2.2c1.5-2 3.8-3.3 6.4-3.3l192 0c3.4 0 6.5 2.2 7.6 5.5l11.9 35.6c10.9 32.8 41.6 54.9 76.2 54.9 44.4 0 80.3-36 80.3-80.3L560 232c0-101.6-82.4-184-184-184L200 48zM160 168c4.4 0 8 3.6 8 8l0 40 40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0 0 40c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-40-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l40 0 0-40c0-4.4 3.6-8 8-8zM384 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm48-80a16 16 0 1 1 0-32 16 16 0 1 1 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGamepadModern = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;